import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UnsubscribeService } from '../../core/services/unsubscribe.service';
import { TranslateModule } from '@ngx-translate/core';
import { filter, takeUntil } from 'rxjs';
import { AuthService } from '@personal-area/global/authorization/services';

@Component({
  selector: 'pac-header',
  standalone: true,
  imports: [
    TranslateModule,
    NgTemplateOutlet,
  ],
  providers: [
    UnsubscribeService,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  readonly isAuthorizedHeaderLocked = input.required<boolean>();
  readonly isHeaderNavigationLocked = input.required<boolean>();

  private _router = inject(Router);
  private _unsubscribe = inject(UnsubscribeService);
  private _authService = inject(AuthService);

  isAuthorized = signal(this._authService.isLoggedIn);

  public ngOnInit(): void {
    this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this._unsubscribe),
      )
      .subscribe(() => this.isAuthorized.set(this._authService.isLoggedIn));
  }
}
